import './suppliers_table.css'

import React, { useState , useEffect, useRef } from 'react'
import Button from '@mui/material/Button';
import {makeStyles} from '@mui/styles';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import Widget_count_elements from '../widget_count_elements/widget_count_elements'


const status = ['En Cours','Refusé','Accepté'];


const columns = [
  { id: 'fullName', label: 'fullName', minWidth: 0 , align: 'left'},
  { id: 'parentCompany', label: "Maison mère", minWidth: 0 , align: 'left'},
  { id: 'purchase_family', label: "Famille d'achat", minWidth: 0, align: 'left' },
  { id: 'reference', label: "reference", minWidth: 0 , align: 'center'},
];


function setStatus(stat){
  return(
    <>
      {
       stat === null
       ?<Button variant="contained" className="status_waiting">{status[0]}</Button>
       :stat === 0
          ?<Button variant="contained" className="status_deny">{status[1]}</Button>
          :<Button variant="contained" className="status_success">{status[2]}</Button>
      }
    </>

  );
}

const useStyles = makeStyles((theme) => ({
  button: { margin: 8,},
  root: {
    '& > *': {
      margin: 8,
    },
  },
  input: {
    display: 'none',
  },
}));



const Suppliers_table = ({categories,lastSuppliers}) => {

  const classes = useStyles();
  const [show_elemnts,setShowing_elements] = useState(false);


//////////////////////
/////////////////////////////////////////////////////////'
///////////////////////////////////

  const getCategorieById = (categorie)=>{
    var tmp_categorie="";
    categories.map((catg)=>{
      categorie.map((id)=>{
        if(catg.id_category === parseInt(id)){
          if(tmp_categorie==="") tmp_categorie = tmp_categorie+catg.name;
          else tmp_categorie = tmp_categorie+", "+catg.name;
        }
      })
    })
    return tmp_categorie;
  }


  //////////////////////
/////////////////////////////////////////////////////////
///////////////////////////////////

  function createData(fullName, parentCompany,purchase_family,reference) {
    return { fullName, parentCompany,purchase_family,reference};
  }

  const rows = [
    lastSuppliers.data.map((supplier, i) => createData(supplier.fullName,supplier.parentCompany,getCategorieById((supplier.purchase_family).split(',')),setStatus(supplier.validate)
      )
    )
  ]

  return (
    <>
      {
        show_elemnts!==true
          ?<Widget_count_elements setShowing_elements={setShowing_elements} elements_number={lastSuppliers.count} progress={lastSuppliers.progress}/>
          :<TableContainer className="suppliers_table" component={Paper}>
      <Table className={classes.table} id="suppliers_table"  onContextMenu={(e) => {e.preventDefault();setShowing_elements(false);console.log("db")}} style={{cursor:'pointer'}} onTouchStartCapture={(e)=>{e.stopPropagation();setShowing_elements(false)}} >
        <TableHead>
          <TableRow>
            <TableCell align="left">Nom Complet</TableCell>
            <TableCell align="left">Maison mère</TableCell>
            <TableCell align="left">Famille d'achat</TableCell>
            <TableCell align="left">Etat de referencement</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {

          categories.length!==0 && lastSuppliers.data.length!==0
            ?rows[0].map((row,index) => {
              return (
                <TableRow key={index} role="checkbox" tabIndex={-1} className="rowsbody">
                  {
                    columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {value}
                        </TableCell>
                      );
                    })
                  }
                </TableRow>
              );
            })
            :<></>
          }
        </TableBody> 
      </Table>
    </TableContainer>
    }

    </>
  )

}

export default Suppliers_table;
